import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PaginatedSearchResultPlayerSearchResultDTO } from '@solverml/api';
import { StatisticsStateService } from '../../controller/statistics-state.service';

@Component({
  selector: 'app-search-tab-player',
  templateUrl: './search-tab-player.component.html',
  styleUrls: ['./search-tab-player.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterLink,
    MatPaginatorModule,
    MatListModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule
  ]
})
export class SearchTabPlayerComponent {

  private state = inject(StatisticsStateService);

  public playersResult$: Observable<PaginatedSearchResultPlayerSearchResultDTO | null>;
  public isLoading$: Observable<boolean>;

  constructor() {
    this.playersResult$ = this.state.playersResult$;
    this.isLoading$ = this.state.isLoadingData$;
  }

  /**
   * Gestiona el evento de cambio de página del paginador.
   */
  public handlePageEvent(e: PageEvent): void {
    this.state.paginatePlayers(e.pageIndex + 1);
  }
}
